@for (timesheet of timesheets; track timesheet) {
  <table-like-layout
    containerClass="!mt-0"
    labelClass="w-[7rem]"
    columnLimit="1"
    [config]="getHeaders(timesheet)"
    [values]="[timesheet]"
    [shouldHideTotal]="true"
    [shouldHideHeaders]="true"
    [additionalContentRowClasses]="['!mt-0']"
    (valueChanged)="handleValueChanged($event)"
  />
}
